import FeatureGates from '@atlaskit/feature-gate-js-client';
import React, { useEffect } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';

import { ENABLEMENT_ACADEMY_IN_ALP_FF } from 'src/constants';
import { HubLayout } from 'src/pages/hubs/LearningPathPage/children/HubLayout';
import { LearningPathsHubLoaderProps } from 'src/pages/hubs/LearningPathPage/loader';

export const EnablementHub: React.FC = () => {
  const navigate = useNavigate();
  const { learningPathsHubData } = useLoaderData() as LearningPathsHubLoaderProps;

  const enablementAcademyEnabled = FeatureGates.checkGate(ENABLEMENT_ACADEMY_IN_ALP_FF);

  useEffect(() => {
    if (!enablementAcademyEnabled) {
      navigate('/');
    }
  }, [enablementAcademyEnabled, navigate]);

  if (!enablementAcademyEnabled) {
    return null;
  }

  return <HubLayout hubData={learningPathsHubData} />;
};
